
export const packages = [
  "@openimis/fe-core",
  "@openimis/fe-admin",
  "@openimis/fe-individual",
  "@openimis/fe-socialprotection",
  "@openimis/fe-opensearchreports",
  "@openimis/fe-home",
  "@openimis/fe-location",
  "@openimis/fe-tools",
  "@openimis/fe-profile",
  "@openimis/fe-tasksmanagement",
  "@openimis/fe-grievancesocialprotection",
  "@openimis/fe-languagefr",
  "@openimis/fe-deduplication",
  "@openimis/fe-paymentcycle",
  "@openimis/fe-calculation",
  "@openimis/fe-payer",
  "@openimis/fe-payment",
  "@openimis/fe-synchokobo",
  "@openimis/fe-validationcommunautaire"
];


export function loadModules(cfg = {}) {
  const loadedModules = [];

  try {
    loadedModules.push(require("@openimis/fe-core").CoreModule(cfg["./frontend-packages/CoreModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-core". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-admin").AdminModule(cfg["./frontend-packages/AdminModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-admin". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-individual").IndividualModule(cfg["./frontend-packages/IndividualModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-individual". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-socialprotection").SocialProtectionModule(cfg["./frontend-packages/SocialProtectionModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-socialprotection". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-opensearchreports").OpenSearchReportsModule(cfg["./frontend-packages/OpenSearchReportsModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-opensearchreports". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-home").HomeModule(cfg["./frontend-packages/HomeModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-home". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-location").LocationModule(cfg["./frontend-packages/LocationModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-location". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-tools").ToolsModule(cfg["./frontend-packages/ToolsModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-tools". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-profile").ProfileModule(cfg["./frontend-packages/ProfileModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-profile". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-tasksmanagement").TasksManagementModule(cfg["./frontend-packages/TasksManagementModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-tasksmanagement". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-grievancesocialprotection").GrievanceSocialProtectionModule(cfg["./frontend-packages/GrievanceSocialProtectionModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-grievancesocialprotection". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-languagefr").LanguageFrModule(cfg["./frontend-packages/LanguageFrModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-languagefr". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-deduplication").DeduplicationModule(cfg["./frontend-packages/DeduplicationModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-deduplication". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-paymentcycle").PaymentCycleModule(cfg["./frontend-packages/PaymentCycleModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-paymentcycle". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-calculation").CalculationModule(cfg["./frontend-packages/CalculationModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-calculation". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-payer").PayerModule(cfg["./frontend-packages/PayerModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-payer". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-payment").PaymentModule(cfg["./frontend-packages/PaymentModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-payment". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-synchokobo").SynchoKoboModule(cfg["./frontend-packages/SynchoKoboModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-synchokobo". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  try {
    loadedModules.push(require("@openimis/fe-validationcommunautaire").ValidationCommunautaireModule(cfg["./frontend-packages/ValidationCommunautaireModule"] || {}));
  } catch (error) {
    alert(`Failed to load module "@openimis/fe-validationcommunautaire". More details can be found in the developer console. Look for: ${error}`);
    console.error(error);
  }

  return loadedModules;
}
